// extracted by mini-css-extract-plugin
export default {"container":"ProfileLatestAssistedPlans_container__tCQsV","img":"ProfileLatestAssistedPlans_img__CpbJC","title":"ProfileLatestAssistedPlans_title__-zeK0"};